<template>
  <div class="v-manualEntry">
    <Input label="发票代码"
           placeholder="请输入10或12位发票代码"
           type="text"
           maxlength="12"
           :reg="[
            {
              pattern: /^[0-9a-zA-Z]{10,12}$/,
              message: '请输入正确的发票代码',
              required: true
            }
          ]"
           v-model="form.invoiceCode" />
    <Input label="发票号码"
           placeholder="请输入8位发票号码"
           maxlength="8"
           type="text"
           :reg="[
            {
              pattern: /^[0-9a-zA-Z]{8}$/,
              message: '请输入正确的发票号码',
              required: true
            }
          ]"
           v-model="form.invoiceNumber" />
    <Input v-if="isShowMoney"
           label="合计金额（不含税）"
           placeholder="请输入不含税金额"
           type="text"
           maxlength="16"
           labelWidth="135px"
           :reg="[
            {
              message: '请输入不含税金额',
              required: true
            },
            {
              pattern: /^\d+(\.\d{2})?$/,
              message: '请输入正确的金额',
              required: true,
            },
          ]"
           v-model="form.totalAmount" />

    <Input v-else
           label="校验码后6位"
           maxlength="6"
           placeholder="请输入校验码后6位"
           type="text"
           labelWidth="95px"
           :reg="[
              {
                pattern: /^[0-9a-zA-Z]{6}$/,
                message: '请填写正确的校验码后6位',
                required: true
              }
            ]"
           v-model="form.checkCode" />
    <DataPicker label="开票日期" 
          placeholder="选择开票日期"
          errorMessage="请选择正确的开票日期"
          :maxDate="maxDate"
          :minDate="minDate"
          v-model="form.billingDate" />

    <div class="buttonGroup">
      <van-button class="goBack" @click="goBack">返回</van-button>
      <van-button type="danger" class="continueUpload" @click="onUpload">点击上传</van-button>
    </div>
  </div>
</template>
<script>
import { checkInvoceType } from '@/utils/invoiceCheck';
import Input from './components/Input.vue';
import DataPicker from './components/DatePicker.vue';

export default {
  components: {
    Input,
    DataPicker,
  },
  data() {
    return {
      form: {
        invoiceCode: '', // 发票代码
        invoiceNumber: '', // 发票号码
        billingDate: '', // 开票日期
        checkCode: '', // 校验码
        totalAmount: '', // 合计金额
      },
      maxDate: new Date(),
      minDate: null,
      isShowMoney: true,
    };
  },
  watch: {
    'form.invoiceCode': {
      handler(n) {
        if (n) {
          console.log(n, '==n');
          if (n.length >= 10) {
            this.isShowMoney = checkInvoceType(n);
          }
        }
      },
      deep: true,
    },
  },
  created() { 
    const dateTime = new Date().getFullYear(); /* 获取现在的年份 */
    this.minDate = new Date(new Date().setFullYear(dateTime - 5)); // 五年后
  },
  computed: {},
  methods: {
    goBack() {
      window.location.href = '/supermarket/v2/uploadTicket';
    },
    verification() {
      // 找到onCheck方法的子组件
      return new Promise((resolve) => {
        const childrenFn = this.$children.filter((v) => v.onCheck).map((v) => v.onCheck());
        Promise.all(childrenFn).then((arr) => {
          const flag = arr.every((v) => v);
          resolve(flag);
        });
      });
    },
    onUpload() {
      console.log(this.form, '==from');
      this.verification().then((valid) => {
        if (valid) {
          this.checkInvoice(this.form);
        }
      });
    },
    checkInvoice(data) {
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.$api.PublicPage.checkAmount({ invoice: data }).then((res) => {
        console.log(res, '==res');
        if (res.code === '200' && res.success) {
          this.$router.push({
            path: '/supermarket/v2/upoladSuccess',
            query: {
              type: this.$route.query.type,
              data: JSON.stringify(res.data),
            },
          });
        } else {
          this.$router.push({
            path: '/supermarket/v2/upoladFail',
            query: {
              type: this.$route.query.type,
            },
          });
        }
      }).finally(() => {
        this.$toast.clear();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.v-manualEntry {
  .buttonGroup {
    margin: 16px;
    display: flex;
    .goBack {
      flex: 1;
      margin-right: 15px;
      border-radius: 4px;
    }
    .continueUpload {
      flex: 1;
      border-radius: 4px;
      background: #ff6538;
    }
    .goBack >>> .van-button__text {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #2f3133;
      text-align: center;
      font-weight: 400;
      line-height: 24px;
    }
    .continueUpload >>> .van-button__text {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      text-align: center;
      font-weight: 600;
      line-height: 24px;
    }
  }
}
</style>
